import React from 'react';
import { motion } from 'framer-motion';
export function MyStory() {
  return <section id="my-story" className="py-24 bg-dark-darker relative overflow-hidden" data-id="element-69">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-70">
        <div className="flex flex-col lg:flex-row items-center gap-16" data-id="element-71">
          {/* Image Side */}
          <motion.div initial={{
          opacity: 0,
          x: -30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8
        }} className="w-full lg:w-1/2 relative" data-id="element-72">
            <div className="relative z-10 border border-dark-lighter p-2 bg-dark" data-id="element-73">
              <img src="https://cdn.magicpatterns.com/uploads/5nHrvwNZdSqcyJADrjQ1dX/mike-curry.png" alt="Mike Curry" className="w-full h-auto grayscale hover:grayscale-0 transition-all duration-700" data-id="element-74" />
            </div>
            {/* Decorative Gold Frame */}
            <div className="absolute top-6 left-6 w-full h-full border-2 border-gold/20 -z-0 hidden lg:block" data-id="element-75"></div>
          </motion.div>

          {/* Content Side */}
          <motion.div initial={{
          opacity: 0,
          x: 30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8
        }} className="w-full lg:w-1/2" data-id="element-76">
            <span className="text-gold font-bold tracking-widest uppercase text-sm mb-2 block" data-id="element-77">
              My Story
            </span>
            <h2 className="font-heading text-4xl md:text-5xl lg:text-6xl text-white mb-8 leading-none" data-id="element-78">
              From Rock Bottom to <br data-id="element-79" />
              <span className="text-gold" data-id="element-80">Radical Purpose</span>
            </h2>

            <div className="space-y-6 text-lg text-gray-400" data-id="element-81">
              <p className="text-xl text-white font-medium italic border-l-4 border-gold pl-6 py-2" data-id="element-82">
                "I missed my mom's last breath because I was high in the
                hospital bathroom."
              </p>

              <p data-id="element-83">
                That moment didn't fix me — but it broke me open. For years I
                was the guy who looked like he had it together. Top performer in
                sales. Nice car. Big smile. But behind it all was a man drowning
                in addiction, disconnection, and shame. I nearly lost everything
                — my family, my career, my life.
              </p>

              <p data-id="element-84">
                Recovery wasn't just about putting down the bottle. It was about
                picking up the pieces of who I really was. Through faith,
                radical honesty, and relentless inner work, I rebuilt
                everything. Today I help other high-achieving men do the same —
                not through motivation, but through transformation.
              </p>
            </div>

            <div className="mt-10" data-id="element-85">
              <a href="#contact" className="inline-block bg-transparent border-2 border-gold text-gold hover:bg-gold hover:text-black font-bold py-3 px-8 rounded-sm uppercase tracking-wider transition-all duration-300" data-id="element-86">
                Book a Free Strategy Session
              </a>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}